import type { SVGProps } from 'react';

const SvgLineGallery = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={17}
    viewBox='0 0 16 17'
    width={16}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M10.001 1.213c1.716 0 3.047.34 3.937 1.23s1.229 2.221 1.229 3.937v4c0 1.716-.34 3.047-1.23 3.937s-2.22 1.23-3.936 1.23h-4c-1.716 0-3.048-.34-3.938-1.23-.889-.89-1.229-2.221-1.229-3.937v-4c0-1.716.34-3.048 1.23-3.937.89-.89 2.221-1.23 3.937-1.23zm3.253 7.879c-.332-.285-.896-.285-1.229 0v.001l-2.773 2.38c-.707.607-1.825.607-2.532 0l-.004-.004-.216-.19c-.261-.224-.687-.277-1.02-.131l-.135.074-2.916 1.956q.151.242.342.432c.61.61 1.613.936 3.23.936h4c1.617 0 2.62-.326 3.23-.936s.936-1.613.936-3.23v-.504zM6 2.213c-1.617 0-2.62.326-3.23.937-.61.61-.937 1.613-.937 3.23v4c0 .741.07 1.353.202 1.858l2.751-1.846v-.001l.137-.083a2.02 2.02 0 0 1 2.102.114l.125.099.005.004.215.19h.001c.333.285.896.285 1.229 0l2.773-2.382c.707-.607 1.824-.606 2.531.001l.262.224V6.38c0-1.617-.326-2.62-.937-3.23-.61-.61-1.612-.937-3.229-.937zM5.999 3.88a1.834 1.834 0 1 1 0 3.668A1.834 1.834 0 0 1 6 3.88m0 1a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667'
      fill='#3889FF'
    />
  </svg>
);
export default SvgLineGallery;
